export default "__VITE_ASSET__BMvkBEz9__"